import { useQuery } from '@apollo/client/react';
import { AdfsSetting } from '../../interfaces';
import LoadingSpinner from '../../components/LoadingSpinner';
import { Link, useParams } from 'react-router-dom';
import { Code, CardMembership, RecentActors } from '@mui/icons-material';
import { Paper, Grid } from '@mui/material';
import { GET_SINGLE_ADFS_BY_BKS_ID } from './ADFSConfig.graphql';

export default function ADFSSubSettings() {
  const params = useParams<{ bksID: string }>();
  let result = params.bksID;
  const bksID = result ? parseInt(result) : undefined;
  const { loading, data } = useQuery<{ adfs: AdfsSetting }>(GET_SINGLE_ADFS_BY_BKS_ID, { variables: { bksID }, fetchPolicy: 'no-cache' });
  if (loading || !data) return <LoadingSpinner />;
  return (
    <>
      <Paper elevation={1}>
        <Grid container spacing={1} direction="row" style={{ padding: 20 }} sx={{justifyContent: 'center'}}>
          <Grid size={12}>
            <Grid container spacing={1} direction="row" style={{ padding: 20 }}>
              <Grid>
                <Link to={'/license/' + bksID}>
                  {' '}
                  <h3>{data && data.adfs && data.adfs.scheme}</h3>
                </Link>
              </Grid>
            </Grid>
          </Grid>
          <Grid size={12}>
            <Grid container spacing={1} direction="row" style={{ padding: 20 }}>
              <Grid>
                <Code htmlColor="#757575" />
              </Grid>
              <Grid>
                <Link to='/generalsetting/' state={data} style={{ textDecoration: 'none' }}>
                  <div>Generelle instillinger</div>
                </Link>
              </Grid>
              <Grid style={{ marginLeft: 40 }}>
                <CardMembership htmlColor="#757575" />
              </Grid>
              <Grid>
                <Link to='/advancesetting/' state={data} style={{ textDecoration: 'none' }}>
                  <div>Avanserte instillinger</div>
                </Link>
              </Grid>
              <Grid style={{ marginLeft: 60 }}>
                <RecentActors htmlColor="#757575" />
              </Grid>
              <Grid>
                <Link to='/authorization/' state={data} style={{ textDecoration: 'none' }}>
                  <div>Client Authorization</div>
                </Link>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}
